<template>
  <div class="bg-[rgba(93,93,152,0.55)] w-full p-4 rounded-md flex flex-col min-h-[400px]">
    <h1 class="chat-title">Chat Privado</h1>

    <div class="search-container">
      <input v-model="searchQuery" type="text" class="search-input" placeholder="Procura Mensagens..." />
    </div>

    <div class="messages-container">
      <div ref="chatWindow" class="chat-window">
        <div class="message" v-for="(message, index) in filteredMessages" :key="index">
          <div class="message-header">
            <strong class="text-orange-500">{{ message.username }}</strong>
          </div>
          <div class="message-body">{{ message.message }}</div>
          <div v-if="message.fileUrl" class="file-link">
            <a :href="message.fileUrl" target="_blank" class="download-link">Download arquivo</a>
          </div>
        </div>
      </div>
    </div>

    <form @submit.prevent="submit" class="message-form">
      <div v-if="chatType === 'private'" class="user-recipient-container">
        <div class="user-dropdown-container">
          <select id="userDropdown" v-model="recipient" @change="openModal" class="dropdown-select">
            <option value="" disabled>Selecione um utilizador</option>
            <option v-for="user in users" :key="user.id" :value="user.user">
              {{ user.user }}
            </option>
          </select>
        </div>
      </div>

      <div class="input-container">
        <input type="text" class="input-field" placeholder="Escreva sua mensagem aquí" v-model="message" />
      </div>

      <div class="input-container">
        <input type="file" class="file-input" @change="handleFileUpload" />
      </div>

      <button type="submit" class="submit-button">
        Enviar
      </button>
    </form>

    <!-- Modal (pop-up) para enviar a mensagem -->
    <div v-if="showModal" class="modal-background">
      <div class="modal-content">
        <h2>Enviar mensagem para {{ recipient }}</h2>
        <form @submit.prevent="submitMessage">
          <div class="input-container">
            <input type="text" class="input-field" placeholder="Escreva sua mensagem" v-model="modalMessage" />
          </div>
          <div class="input-container">
            <input type="file" class="file-input" @change="handleFileUpload" />
          </div>
          <button type="submit" class="submit-button">Enviar</button>
          <button @click="closeModal" class="close-button">Cancelar</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed, nextTick } from 'vue';
// import Pusher from 'pusher-js';
import axios from 'axios';

export default {
  name: 'PrivateChat',
  setup() {
    const username = ref('');
    const messages = ref([]);
    const message = ref('');
    const recipient = ref('');
    const searchQuery = ref('');
    const chatType = ref('private');
    const baseURL = process.env.VUE_APP_URL_BASE;
    const chatWindow = ref(null);
    const users = ref([]);
    const file = ref(null);
    const showModal = ref(false);
    const modalMessage = ref('');

    onMounted(async () => {
      const userLogado = JSON.parse(localStorage.getItem('user'));
      if (userLogado && userLogado.user) {
        username.value = userLogado.user;
      }

      const storedMessages = JSON.parse(localStorage.getItem('chatMessages'));
      if (storedMessages) {
        messages.value = storedMessages;
      }

      // Pusher.logToConsole = true;

      // const pusher = new Pusher('1c5160e5c87872d20a6f', {
      //   cluster: 'eu',
      // });

      // if (username.value) {
      //   const privateChannel = pusher.subscribe(`user-${username.value}`);
      //   privateChannel.bind('message', data => {
      //     messages.value.push(data);
      //     scrollToBottom();
      //   });
      // }
      await getUsers();
    });

    watch(messages, (newMessages) => {
      localStorage.setItem('chatMessages', JSON.stringify(newMessages));
    }, { deep: true });

    const filteredMessages = computed(() => {
      return messages.value.filter(message =>
        message.message.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    });

    const submitMessage = async () => {
      if (!modalMessage.value || !recipient.value) {
        alert('Por favor, insira o destinatário e a mensagem.');
        return;
      }

      const formData = new FormData();
      formData.append('username', username.value);
      formData.append('message', modalMessage.value);
      formData.append('recipient', recipient.value);
      formData.append('chatType', chatType.value);
      if (file.value) {
        formData.append('file', file.value);
      }

      const response = await axios.post(`${baseURL}/api/v1/messages/`, formData);

      // Adiciona a mensagem à lista de mensagens
      messages.value.push({
        username: response.data.username,
        message: response.data.message,
        fileUrl: response.data.fileUrl,
        timestamp: response.data.timestamp,
      });

      // Limpa os campos após o envio
      modalMessage.value = '';
      file.value = null;
      showModal.value = false;

      scrollToBottom();
    };

    const handleFileUpload = (event) => {
      file.value = event.target.files[0];
    };

    const getUsers = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/v1/utilizador/?user_only=1`);
        if (response.status === 200) {
          users.value = response.data.data;
        } else {
          users.value = [];
        }
      } catch (error) {
        console.error('Erro ao buscar utilizadores:', error);
        users.value = [];
      }
    };

    const scrollToBottom = () => {
      nextTick(() => {
        if (chatWindow.value) {
          chatWindow.value.scrollTop = chatWindow.value.scrollHeight;
        }
      });
    };

    const openModal = () => {
      if (recipient.value) {
        showModal.value = true;
      }
    };

    const closeModal = () => {
      showModal.value = false;
      recipient.value = '';
    };

    return {
      username,
      messages,
      message,
      recipient,
      searchQuery,
      chatType,
      submitMessage,
      users,
      filteredMessages,
      chatWindow,
      handleFileUpload,
      showModal,
      modalMessage,
      openModal,
      closeModal,
    };
  },
};
</script>


<style scoped>

.chat-container {
  background: rgba(93, 93, 152, 0.55);
  width: 100%;
  padding: 1rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  min-height: 400px;
}

.chat-title {
  color: #ff9b05;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.search-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.search-input {
  padding: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid #cccccc;
  font-size: 0.875rem;
  width: 100%;
  background-color: white;
  color: black;
}

.messages-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
}

.chat-window {
  background: #545484;
  padding: 0.5rem;
  border-radius: 0.5rem;
  overflow-y: auto;
  max-height: 300px;
  min-height: 200px;
  scrollbar-width: thin; /* For Firefox */
  scrollbar-color: #ff9b05 #545484;
}

/* Custom scrollbar for Webkit browsers (Chrome, Safari) */
.chat-window::-webkit-scrollbar {
  width: 8px;
}

.chat-window::-webkit-scrollbar-track {
  background: #545484;
}

.chat-window::-webkit-scrollbar-thumb {
  background: #ff9b05;
  border-radius: 8px;
}

.message {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.message-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.message-username {
  color: white;
}

.message-body {
  color: white;
  font-size: 0.875rem;
}

.file-link {
  margin-top: 0.5rem;
}

.message-form {
  margin-top: 1rem;
}

.user-recipient-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.user-dropdown-container {
  flex: 1;
}

.dropdown-select {
  border-radius: 0.5rem;
  padding: 0.5rem;
  background-color: white;
  color: black;
  width: 100%;
}

.input-container {
  flex: 1;
}

.input-field {
  border-radius: 0.5rem;
  padding: 0.5rem;
  background-color: white;
  color: black;
  width: 100%;
}

.file-input {
  margin-bottom: 1rem;
}

.submit-button {
  padding: 0.5rem;
  border-radius: 0.5rem;
  background-color: #38bdf8;
  color: white;
  font-size: 0.875rem;
  width: 100%;
  cursor: pointer;
  border: none;
}

.submit-button:hover {
  background-color: #0ea5e9;
}

.file-link {
  margin-top: 0.5rem;
}

.download-link {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #ff9b05; /* Cor de fundo laranja */
  color: white; /* Cor do texto */
  border-radius: 0.5rem;
  text-decoration: none; /* Remove o sublinhado padrão */
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.download-link:hover {
  background-color: #e89a03; /* Tom de laranja mais escuro ao passar o mouse */
}

.modal-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: white;
  padding: 1.5rem;
  border-radius: 0.5rem;
  width: 400px;
  display: flex;
  flex-direction: column;
}

.close-button {
  background-color: #e53e3e;
  color: white;
  padding: 0.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  margin-top: 1rem;
}

.close-button:hover {
  background-color: #c53030;
}
</style>



<!-- <template>
  <div class="bg-[rgba(93,93,152,0.55)] w-full p-4 rounded-md flex flex-col min-h-[400px]">
    <h1 class="chat-title">Chat Privado</h1>

    <div class="search-container">
      <input v-model="searchQuery" type="text" class="search-input" placeholder="Procura Mensagens..." />
    </div>

    <div class="messages-container">
      <div ref="chatWindow" class="chat-window">
        <div class="message" v-for="(message, index) in filteredMessages" :key="index">
          <div class="message-header">
            <strong class="text-orange-500">{{ message.username }}</strong>
          </div>
          <div class="message-body">{{ message.message }}</div>
          <div v-if="message.fileUrl" class="file-link">
            <a :href="message.fileUrl" target="_blank" class="download-link">Download arquivo</a>
          </div>
        </div>
      </div>
    </div>

    <form @submit.prevent="submit" class="message-form">
      <div v-if="chatType === 'private'" class="user-recipient-container">
        <div class="user-dropdown-container">
          <select id="userDropdown" v-model="recipient" class="dropdown-select">
            <option value="" disabled>Selecione um utilizador</option>
            <option v-for="user in users" :key="user.id" :value="user.user">
              {{ user.user }}
            </option>
          </select>
        </div>
      </div>

      <div class="input-container">
        <input type="text" class="input-field" placeholder="Escreva sua mensagem aquí" v-model="message" />
      </div>

      <div class="input-container">
        <input type="file" class="file-input" @change="handleFileUpload" />
      </div>

      <button type="submit" class="submit-button">
        Enviar
      </button>
    </form>
  </div>
</template>

<script>
import { ref, onMounted, watch, computed, nextTick } from 'vue';
import Pusher from 'pusher-js';
import axios from 'axios';

export default {
  name: 'PrivateChat',
  setup() {
    const username = ref('');
    const messages = ref([]);
    const message = ref('');
    const recipient = ref('');
    const searchQuery = ref('');
    const chatType = ref('private');
    const baseURL = process.env.VUE_APP_URL_BASE;
    const chatWindow = ref(null);
    const users = ref([]);
    const file = ref(null);

    onMounted(async () => {
      const userLogado = JSON.parse(localStorage.getItem('user'));
      if (userLogado && userLogado.user) {
        username.value = userLogado.user;
      }

      const storedMessages = JSON.parse(localStorage.getItem('chatMessages'));
      if (storedMessages) {
        messages.value = storedMessages;
      }

      Pusher.logToConsole = true;

      const pusher = new Pusher('1c5160e5c87872d20a6f', {
        cluster: 'eu',
      });

      if (username.value) {
        const privateChannel = pusher.subscribe(`user-${username.value}`);
        privateChannel.bind('message', data => {
          messages.value.push(data);
          scrollToBottom();
        });
      }
      await getUsers();
    });

    watch(messages, (newMessages) => {
      localStorage.setItem('chatMessages', JSON.stringify(newMessages));
    }, { deep: true });

    const filteredMessages = computed(() => {
      return messages.value.filter(message =>
        message.message.toLowerCase().includes(searchQuery.value.toLowerCase())
      );
    });

    const submit = async () => {
      if (!message.value || (chatType.value === 'private' && !recipient.value)) {
        alert('Por favor, insira o destinatário e a mensagem se for um chat privado.');
        return;
      }

      const formData = new FormData();
      formData.append('username', username.value);
      formData.append('message', message.value);
      formData.append('recipient', recipient.value);
      formData.append('chatType', chatType.value);
      if (file.value) {
        formData.append('file', file.value);
      }

      const response = await axios.post(`${baseURL}/api/v1/messages/`, formData);

      // Adiciona a mensagem à lista de mensagens
      messages.value.push({
        username: response.data.username,
        message: response.data.message,
        fileUrl: response.data.fileUrl,
        timestamp: response.data.timestamp,
      });

      // Limpa os campos após o envio
      message.value = '';
      file.value = null;

      // Scroll to bottom
      scrollToBottom();
    };

    const deleteMessage = async (messageId) => {
      try {
        await axios.post(`${baseURL}/api/v1/messages/${messageId}/delete/`);
        const messageIndex = messages.value.findIndex(msg => msg.id === messageId);
        if (messageIndex !== -1) {
          messages.value[messageIndex].status = 'deleted';
        }
      } catch (error) {
        console.error('Erro ao apagar a mensagem:', error);
      }
    };

    const handleFileUpload = (event) => {
      file.value = event.target.files[0];
    };

    const getUsers = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/v1/utilizador/?user_only=1`);
        if (response.status === 200) {
          users.value = response.data.data;
        } else {
          users.value = [];
        }
      } catch (error) {
        console.error('Erro ao buscar utilizadores:', error);
        users.value = [];
      }
    };

    const scrollToBottom = () => {
      nextTick(() => {
        if (chatWindow.value) {
          chatWindow.value.scrollTop = chatWindow.value.scrollHeight;
        }
      });
    };

    return {
      username,
      messages,
      message,
      recipient,
      searchQuery,
      chatType,
      submit,
      users,
      deleteMessage,
      filteredMessages,
      chatWindow,
      handleFileUpload,
    };
  },
};
</script>

<style scoped>
.chat-container {
  background: rgba(93, 93, 152, 0.55);
  width: 100%;
  padding: 1rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  min-height: 400px;
}

.chat-title {
  color: #ff9b05;
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.search-container {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
}

.search-input {
  padding: 0.5rem;
  border-radius: 0.5rem;
  border: 1px solid #cccccc;
  font-size: 0.875rem;
  width: 100%;
  background-color: white;
  color: black;
}

.messages-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem;
}

.chat-window {
  background: #545484;
  padding: 0.5rem;
  border-radius: 0.5rem;
  overflow-y: auto;
  max-height: 300px;
  min-height: 200px;
  scrollbar-width: thin; /* For Firefox */
  scrollbar-color: #ff9b05 #545484;
}

/* Custom scrollbar for Webkit browsers (Chrome, Safari) */
.chat-window::-webkit-scrollbar {
  width: 8px;
}

.chat-window::-webkit-scrollbar-track {
  background: #545484;
}

.chat-window::-webkit-scrollbar-thumb {
  background: #ff9b05;
  border-radius: 8px;
}

.message {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.message-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.message-username {
  color: white;
}

.message-body {
  color: white;
  font-size: 0.875rem;
}

.file-link {
  margin-top: 0.5rem;
}

.message-form {
  margin-top: 1rem;
}

.user-recipient-container {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
}

.user-dropdown-container {
  flex: 1;
}

.dropdown-select {
  border-radius: 0.5rem;
  padding: 0.5rem;
  background-color: white;
  color: black;
  width: 100%;
}

.input-container {
  flex: 1;
}

.input-field {
  border-radius: 0.5rem;
  padding: 0.5rem;
  background-color: white;
  color: black;
  width: 100%;
}

.file-input {
  margin-bottom: 1rem;
}

.submit-button {
  padding: 0.5rem;
  border-radius: 0.5rem;
  background-color: #38bdf8;
  color: white;
  font-size: 0.875rem;
  width: 100%;
  cursor: pointer;
  border: none;
}

.submit-button:hover {
  background-color: #0ea5e9;
}

.file-link {
  margin-top: 0.5rem;
}

.download-link {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #ff9b05; /* Cor de fundo laranja */
  color: white; /* Cor do texto */
  border-radius: 0.5rem;
  text-decoration: none; /* Remove o sublinhado padrão */
  font-weight: bold;
  transition: background-color 0.3s ease;
}

.download-link:hover {
  background-color: #e89a03; /* Tom de laranja mais escuro ao passar o mouse */
}
</style> -->
